import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5bd5ed6d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "checkout-charity" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col--12" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "col--12 col-md--6 image-column" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "col--12 col-md--6" }
const _hoisted_8 = {
  key: 0,
  class: "error"
}
const _hoisted_9 = { class: "charity-buttons" }
const _hoisted_10 = {
  key: 0,
  class: "giftaid"
}
const _hoisted_11 = { class: "giftaid__title" }
const _hoisted_12 = { class: "giftaid__disclaimer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseDropdown = _resolveComponent("BaseDropdown")!
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_BaseCheckbox = _resolveComponent("BaseCheckbox")!
  const _component_BaseInput = _resolveComponent("BaseInput")!
  const _component_BaseSection = _resolveComponent("BaseSection")!

  return (_ctx.charity.content)
    ? (_openBlock(), _createBlock(_component_BaseSection, {
        key: 0,
        errors: _ctx.v$.$errors
      }, {
        header: _withCtx(() => [
          _createElementVNode("h4", null, _toDisplayString(_ctx.charity.content.title), 1)
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", {
                  class: "xhtml",
                  innerHTML: _ctx.charity.content.description
                }, null, 8, _hoisted_4)
              ]),
              _createElementVNode("div", _hoisted_5, [
                (_ctx.charity.content.image)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _ctx.charity.content.image.url,
                      alt: ""
                    }, null, 8, _hoisted_6))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_BaseDropdown, {
                  label: 'Donation',
                  placeholder: 'Select an amount',
                  name: "donationAmount",
                  options: _ctx.donationOptions,
                  modelValue: _ctx.v$.resourceCode.$model,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.v$.resourceCode.$model) = $event))
                }, null, 8, ["options", "modelValue"]),
                (_ctx.error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.error), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_BaseButton, {
                    class: _normalizeClass(["button--white", {active: _ctx.charityAdded}]),
                    onClick: _ctx.handleAddDonation
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Add donation")
                    ]),
                    _: 1
                  }, 8, ["class", "onClick"]),
                  _createVNode(_component_BaseButton, {
                    class: _normalizeClass(["button--white", {active: _ctx.noDonation}]),
                    onClick: _ctx.removeDonation
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("No thanks")
                    ]),
                    _: 1
                  }, 8, ["class", "onClick"])
                ])
              ])
            ]),
            (_ctx.charityAdded)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.$t('booking.charity.giftaid.title')), 1),
                  _createElementVNode("p", null, _toDisplayString(_ctx.$t('booking.charity.giftaid.body')), 1),
                  _createVNode(_component_BaseCheckbox, {
                    label: _ctx.$t('booking.charity.giftaid.terms', {charity: _ctx.charity.content.recipient}),
                    modelValue: _ctx.v$.giftAid.$model,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.v$.giftAid.$model) = $event)),
                    name: `giftaid-${_ctx.charity.content.resource_prefix}`,
                    id: `giftaid_terms-${_ctx.charity.content.resource_prefix}`
                  }, null, 8, ["label", "modelValue", "name", "id"]),
                  (_ctx.noNewsletter !== true)
                    ? (_openBlock(), _createBlock(_component_BaseCheckbox, {
                        key: 0,
                        label: "If you would you like to receive marketing newsletters from IOSWT, tick this box",
                        modelValue: _ctx.v$.newsletter.$model,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.v$.newsletter.$model) = $event)),
                        name: `giftaid-newsletter-${_ctx.charity.content.resource_prefix}`,
                        id: `giftaid_newsletter-${_ctx.charity.content.resource_prefix}`
                      }, null, 8, ["modelValue", "name", "id"]))
                    : _createCommentVNode("", true),
                  (_ctx.v$.newsletter.$model)
                    ? (_openBlock(), _createBlock(_component_BaseInput, {
                        key: 1,
                        placeholder: "E-mail for marketing newsletter",
                        name: "giftAidEmail",
                        messages: { email: 'bajs'},
                        hasError: _ctx.v$.email.$error,
                        valid: !_ctx.v$.email.$invalid,
                        modelValue: _ctx.v$.email.$model,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.v$.email.$model) = $event))
                      }, null, 8, ["hasError", "valid", "modelValue"]))
                    : _createCommentVNode("", true),
                  _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.$t('booking.charity.giftaid.disclaimer', {charity: _ctx.charity.content.recipient})), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["errors"]))
    : _createCommentVNode("", true)
}